import { render, staticRenderFns } from "./newExpense.vue?vue&type=template&id=0fff82f9"
import script from "./newExpense.vue?vue&type=script&lang=js"
export * from "./newExpense.vue?vue&type=script&lang=js"
import style0 from "./newExpense.vue?vue&type=style&index=0&id=0fff82f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports